import { Tooltip } from "@heroui/react";
import { Info } from "@phosphor-icons/react";
import { ReactElement, cloneElement } from "react";

interface DataCardProps {
  title: string;
  subtitle?: string;
  label?: string;
  icon: ReactElement<any>;
  iconWeight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
  iconSize?: number;
  tooltip?: {
    content: string;
    visible: boolean;
  };
  percentage?: number;
}

export const DataCard = ({
  title,
  subtitle,
  label,
  icon,
  iconWeight = "duotone",
  iconSize = 18,
  tooltip,
  percentage,
}: DataCardProps) => {
  const iconWithProps = cloneElement(icon, {
    weight: iconWeight,
    size: iconSize,
  });
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-neutral-primary/20 p-3.5">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          {iconWithProps}
          <p className="text-xs font-medium uppercase tracking-wider">
            {subtitle}
          </p>
        </div>
        {tooltip && tooltip.visible && (
          <Tooltip content={tooltip.content}>
            <Info weight="bold" size={16} className="cursor-pointer" />
          </Tooltip>
        )}
      </header>
      <p className="text-2xl font-semi-bold text-neutral-primary">{title}</p>
      {label && (
        <p className="w-fit rounded-full border border-neutral-secondary-mid px-2 text-center text-sm font-medium text-neutral-secondary-mid">
          {label}
        </p>
      )}
      {percentage && (
        <p className="text-sm font-medium text-neutral-secondary-mid">
          {percentage.toFixed(2)}%
        </p>
      )}
    </div>
  );
};
